import { useState } from "react";
import { 
  Globe, Palette, Car, Briefcase, GraduationCap, Users, Heart, 
  Utensils, Gamepad2, Home, Scale, Newspaper, Wallet, PawPrint, 
  Church, TestTube, ShoppingBag, Trophy, Sparkles, Computer, 
  Plane, ShieldAlert, Diamond, Cigarette, Frown, OctagonX, Bug, 
  Gamepad, LucideIcon
} from "lucide-react";
import { Label } from "@/components/ui/label";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";

interface IconOption {
  name: string;
  icon: LucideIcon;
}

const availableIcons: IconOption[] = [
  { name: "Globe", icon: Globe },
  { name: "Palette", icon: Palette },
  { name: "Car", icon: Car },
  { name: "Briefcase", icon: Briefcase },
  { name: "GraduationCap", icon: GraduationCap },
  { name: "Users", icon: Users },
  { name: "Heart", icon: Heart },
  { name: "Utensils", icon: Utensils },
  { name: "Gamepad2", icon: Gamepad2 },
  { name: "Home", icon: Home },
  { name: "Scale", icon: Scale },
  { name: "Newspaper", icon: Newspaper },
  { name: "Wallet", icon: Wallet },
  { name: "PawPrint", icon: PawPrint },
  { name: "Church", icon: Church },
  { name: "TestTube", icon: TestTube },
  { name: "ShoppingBag", icon: ShoppingBag },
  { name: "Trophy", icon: Trophy },
  { name: "Sparkles", icon: Sparkles },
  { name: "Computer", icon: Computer },
  { name: "Plane", icon: Plane },
  { name: "ShieldAlert", icon: ShieldAlert },
  { name: "Diamond", icon: Diamond },
  { name: "Cigarette", icon: Cigarette },
  { name: "Frown", icon: Frown },
  { name: "OctagonX", icon: OctagonX },
  { name: "Bug", icon: Bug },
  { name: "Gamepad", icon: Gamepad },
];

interface IconSelectorProps {
  value: string;
  onChange: (iconName: string) => void;
}

export const IconSelector = ({ value, onChange }: IconSelectorProps) => {
  const selectedIcon = availableIcons.find(i => i.name === value) || availableIcons[0];

  return (
    <div className="space-y-2">
      <Label>Icon *</Label>
      <ScrollArea className="h-48 rounded-md border p-4">
        <div className="grid grid-cols-6 gap-2">
          {availableIcons.map((iconOption) => {
            const IconComponent = iconOption.icon;
            const isSelected = value === iconOption.name;
            
            return (
              <button
                key={iconOption.name}
                type="button"
                onClick={() => onChange(iconOption.name)}
                className={cn(
                  "flex items-center justify-center p-3 rounded-md transition-colors hover:bg-gray-100",
                  isSelected && "bg-primary text-primary-foreground hover:bg-primary/90"
                )}
                title={iconOption.name}
              >
                <IconComponent className="w-5 h-5" />
              </button>
            );
          })}
        </div>
      </ScrollArea>
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <span>Selected:</span>
        <div className="flex items-center gap-1">
          {(() => {
            const SelectedIconComponent = selectedIcon.icon;
            return <SelectedIconComponent className="w-4 h-4" />;
          })()}
          <span>{selectedIcon.name}</span>
        </div>
      </div>
    </div>
  );
};
